import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/fleetLeaderboard';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const {
      goalId, runId, offset, limit, search, minScore, maxScore, moversOnly, order,
    } = action?.payload || {};
    const response = yield call(
      axios.get,
      `${config.API_URL}/goals/${goalId}/fleet/leaderboard`,
      {
        headers: getLocalUser(),
        params: {
          ...(runId ? { run_id: runId } : {}),
          offset: offset || 0,
          limit: limit || 50,
          ...(search ? { search } : {}),
          ...(minScore != null ? { min_score: minScore } : {}),
          ...(maxScore != null ? { max_score: maxScore } : {}),
          ...(moversOnly ? { movers_only: 1 } : {}),
          ...(order ? { order } : {}),
        },
      },
    );
    yield put(fetchSuccess(response?.data?.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
